import { Controller } from '@hotwired/stimulus';
import { useIntersection, useDispatch, useWindowResize } from 'stimulus-use';

export const create = () => {
	return class extends Controller {
		static targets = ['element'];

		connect() {
			this.delay = 200;
			this.elements = this.hasElementTarget ? this.elementTargets : [];
			this.loaded = false;

			useWindowResize(this);
			useDispatch(this);
			useIntersection(this, {
				treshold: 0.2,
			});
		}

		appear() {
			this.animate();
		}

		animate() {
			this.elements.forEach((el, i) => {
				setTimeout(() => {
					el.classList.add('is-animated');
				}, this.delay * i);
			});

			this.disconnect();
		}

		windowResize() {
			// prevent triggering resize after page load
			if (this.loaded) {
				this.animate();
			}
			this.loaded = true;
		}
	};
};
